import { defineAsyncComponent } from "vue";
import HeroHeader from "../innovadis/inno-hero-header.vue";
import HomeCategories from "../innovadis/inno-home-categories.vue";
import HtmlBlock from "../innovadis/inno-html-block.vue";
import News from "../innovadis/inno-news.vue";
import PartnerBlock from "../innovadis/inno-partner-block.vue";
import ProductCategories from "../innovadis/inno-product-categories.vue";
import InnoProductInfo from "../innovadis/inno-product-info.vue";
import RelatedProductSlider from "../innovadis/inno-related-products-slider.vue";
import InnoRelatedProductsDetail from "../innovadis/inno-related-products-detail.vue";
import TextImageBlock from "../innovadis/inno-text-image-block.vue";
import CallToActionWithImage from "./call-to-action-with-image.vue";
import CallToAction from "./call-to-action.vue";
import DemoProductList from "./demo-product-list.vue";
import FAQ from "./faq.vue";
import Features from "./features.vue";
import ImageBlock from "./image-block.vue";
import Login from "./login.vue";
import PromoText from "./promo-text.vue";
import SubscribeForm from "./subscribe-form.vue";
import TextBlock from "./text-block.vue";
import TitleBlock from "./title-block.vue";
import VideoBlock from "../innovadis/inno-video-block.vue";
import Slider from "../innovadis/inno-slider.vue";
import ThreeColumnPromotion from "../innovadis/inno-three-column-promotion.vue";
import LargeProductSlider from "../innovadis/inno-large-product-slider.vue";
import type { Component } from "vue";

// Innovadis custom. The registration of the components for the page builder is now in client-app/plugins/builder-preview/register-components.ts

const ProductsBlock = defineAsyncComponent(() => import("./products-block.vue"));
const Category = defineAsyncComponent(() => import("./../../catalog/components/category.vue"));

export const templateBlocks: { [key: string]: Component } = {
  "call-to-action": CallToAction,
  "call-to-action-with-image": CallToActionWithImage,
  "subscribe-form": SubscribeForm,
  products: ProductsBlock,
  "title-block": TitleBlock,
  "home-categories": HomeCategories,
  "product-categories": ProductCategories,
  faq: FAQ,
  "hero-header": HeroHeader,
  "demo-product-list": DemoProductList,
  features: Features,
  "image-block": ImageBlock,
  login: Login,
  "product-info": InnoProductInfo,
  "video-block": VideoBlock,
  "promo-text": PromoText,
  slider: Slider,
  "text-block": TextBlock,
  "related-products-slider": RelatedProductSlider,
  "related-products": InnoRelatedProductsDetail,
  "text-image-block": TextImageBlock,
  "partner-block": PartnerBlock,
  news: News,
  "html-block": HtmlBlock,
  "three-column-promotion": ThreeColumnPromotion,
  "large-product-slider": LargeProductSlider,
  category: Category,
};
